import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class ReportJob extends Form {

    constructor(data = {}) {
        super(data);

        this.export_report_links = false;
    }

    /**
     * Completed Report Job Index
     *
     * @param append
     * @returns {Promise | Promise<unknown>}
     */
    index(append = false) {
        return this.loadIndexData('/report/job/complete', append);
    }

    /**
     * Pending Report Job Index
     *
     * @param append
     * @returns {Promise | Promise<unknown>}
     */
    pendingIndex(append = false) {
        return this.loadIndexData('/report/job/pending', append);
    }

    /**
     * Generate Export links for all files
     *
     * @param uuid
     * @returns {Promise<unknown>}
     */
    exportReport(uuid) {
        let self = this;

        return new Promise((resolve, reject) => {

            self.export_report_links = false;

            axios.get(this.api_prefix + '/report/queue/export/' + uuid)
                .then(response => {

                    self.export_report_links = response.data;

                    resolve(response.data);
                }).catch(error => {
                    reject(error);
                });
        });
    }

}
